module.exports = __webpack_public_path__ + "img/customer_design_7.4d42a5a.jpg";